import Vue from 'vue'
import Vuex from 'vuex'
import OfficialAccounts from "./official-account" //存放所有关注的公众号
import contact from './contacts' //存放所有联系人的数据
import mutations from "./mutations"
import actions from "./actions"
import getters from "./getters"
Vue.use(Vuex)
    // 统一管理接口域名 
let apiPublicDomain = '//vrapi.snail.com/'
const state = {
    currentLang: "zh", //当前使用的语言 zh：简体中文 en:英文 后期需要
    newMsgCount: 0, //新消息数量
    allContacts: contact.contacts, //所有联系人
    OfficialAccounts: OfficialAccounts, //所有关注的公众号
    currentPageName: "微信", //用于在wx-header组件中显示当前页标题
    //backPageName: "", //用于在返回按钮出 显示前一页名字 已遗弃
    headerStatus: true, //显示（true）/隐藏（false）wx-header组件
    tipsStatus: false, //控制首页右上角菜单的显示(true)/隐藏(false)
    // 所有接口地址 后期需要
    apiUrl: {
        demo: apiPublicDomain + ""
    },
    msgList: {
        stickMsg: [], //置顶消息列表 后期需要
        baseMsg: [{ //普通消息列表
                "mid": 1, //消息的id 唯一标识，重要
                "type": "friend",
                "group_name": "",
                "group_qrCode": "",
                "read": true, //true；已读 false：未读
                "newMsgCount": 1,
                "quiet": false, // true：消息免打扰 false：提示此好友/群的新消息
                "msg": [{ //对话框的聊天记录 新消息 push 进
                    "text": "长按这些白色框消息，唤醒消息操作菜单，长按这些白色框消息，唤醒消息操作菜单",
                    "date": 1488117964495,
                    "name": "阿西",
                    "headerUrl": "/images/header/header01.png"
                }, {
                    "text": '点击空白处，操作菜单消失',
                    "date": 1488117964495,
                    "name": "阿西",
                    "headerUrl": "/images/header/header01.png"
                }, {
                    "text": '你们9点出发，别忘了',
                    "date": 1488117964495,
                    "name": "阿西",
                    "headerUrl": "/images/header/header01.png"
                }],
                "user": [contact.getUserInfo('wxid_zhaohd')] // 此消息的用户数组 长度为1则为私聊 长度大于1则为群聊
            },
            {
                "mid": 2,
                "type": "group",
                "group_name": "影视客户讨论群",
                "group_qrCode": "",
                "read": false,
                "newMsgCount": 1,
                "quiet": true,
                "msg": [{
                        "text": "长按消息，唤醒消息操作菜单",
                        "date": 1488117964495,
                        "name": "夜华",
                        "headerUrl": "/images/header/yehua.jpg"
                    }, {
                        "text": '点击空白处，操作菜单消失',
                        "date": 1488117964495,
                        "name": "小闲闲",
                        "headerUrl": "/images/header/new/文贤.png"
                    },
                    {
                        "text": '感觉还可以，再优化一版吧',
                        "date": 1488117964495,
                        "name": "夜华",
                        "headerUrl": "/images/header/yehua.jpg"
                    }
                ],
                "user": [contact.getUserInfo('wxid_wenxian2012'), contact.getUserInfo('wxid_yehua')]
            },
            {
                "mid": 3,
                "type": "group",
                "group_name": "销售部西西小组",
                "group_qrCode": "",
                "read": true,
                "newMsgCount": 1,
                "quiet": true,
                "msg": [{
                    "text": '早上好，希望在这里能学到很多东西。',
                    "date": 1488117964495,
                    "name": "小晴天",
                    "headerUrl": "/images/header/new/小晴天.png"
                }],
                "user": [contact.getUserInfo('wxid_chenz'), contact.getUserInfo('wxid_wenxian2012'), contact.getUserInfo('wxid_xiaoqt')]
            },
            {
                "mid": 4,
                "type": "friend",
                "group_name": "",
                "group_qrCode": "",
                "read": false,
                "newMsgCount": 4,
                "quiet": false,
                "msg": [{
                    "text": "长按消息，唤醒消息操作菜单",
                    "date": 1488117964495,
                    "name": "陈增",
                    "headerUrl": "/images/header/new/陈增.png"
                }, {
                    "text": '点击空白处，操作菜单消失',
                    "date": 1488117964495,
                    "name": "陈增",
                    "headerUrl": "/images/header/new/陈增.png"
                }, {
                    "text": '容我三思',
                    "date": 1488117964495,
                    "name": "陈增",
                    "headerUrl": "/images/header/new/陈增.png"
                }],
                "user": [contact.getUserInfo('wxid_chenz')]
            },
            {
                "mid": 5,
                "type": "friend",
                "group_name": "",
                "group_qrCode": "",
                "read": true,
                "newMsgCount": 1,
                "quiet": false,
                "msg": [{
                    "text": '',
                    "date": 1488117964495,
                    "name": "阿达",
                    "headerUrl": "/images/header/new/阿达.png"
                }],
                "user": [contact.getUserInfo('wxid_ada')]
            },
            {
                "mid": 6,
                "type": "friend",
                "group_name": "",
                "group_qrCode": "",
                "read": true,
                "newMsgCount": 1,
                "quiet": false,
                "msg": [{
                    "text": '小闲闲，帮我外卖拿一下呗',
                    "date": 1488117964495,
                    "name": "小晴天",
                    "headerUrl": "/images/header/new/小晴天.png"
                }],
                "user": [contact.getUserInfo('wxid_xiaoqt')]
            },
            {
                "mid": 7,
                "type": "friend",
                "group_name": "",
                "group_qrCode": "",
                "read": false,
                "newMsgCount": 1,
                "quiet": false,
                "msg": [{
                    "text": '家长，5点过来接哦',
                    "date": 1488117964495,
                    "name": "潘老师",
                    "headerUrl": "/images/header/new/潘老师.png"
                }],
                "user": [contact.getUserInfo('wxid_panls')]
            }
        ]
    }
}
export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})